import { render, staticRenderFns } from "./AcceptTest.vue?vue&type=template&id=ed612270&"
import script from "./AcceptTest.vue?vue&type=script&lang=js&"
export * from "./AcceptTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports